import get from 'lodash.get';

const getActive = (rootState) => get(rootState, 'subscriptions.active', null);

export default getActive;
